import {Component, signal} from '@angular/core';
import {NbButtonModule} from "@nebular/theme";
import {Title} from "@angular/platform-browser";
import {ActivatedRoute, Router} from "@angular/router";
import {UsersService} from "../../services/users.service";
import {StorageService} from "../../services/storage.service";
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-invite-teammates',
  standalone: true,
    imports: [
    TranslateModule,
        NbButtonModule
    ],
  templateUrl: './invite-teammates.component.html',
  styleUrl: './invite-teammates.component.scss'
})
export class InviteTeammatesComponent {
  currentTitle!: string;
  teamsList = signal<any[]>([]);

  constructor(private readonly title: Title,
              private usersService: UsersService,
              private storageService: StorageService,
              private router: Router, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.currentTitle = this.title.getTitle();
    this.usersService.userTeams(this.storageService.user().user_id).subscribe((data: any) => {
      this.teamsList.set(data);
    })
  }

  copyToClipboard(text: string) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
  }

  invitationLink(teamId: string) {
    const baseUrl = this.removeLastSlash(window.location.origin);
    const path = this.removeFirstSlash(this.router.createUrlTree(['teams', teamId, 'player-registration']).toString());
    return `${baseUrl}/${path}`;
  }

  removeFirstSlash(input: string): string {
    return input.replace(/^\/+/, '');
  }

  removeLastSlash(input: string): string {
    return input.replace(/\/$/, '');
  }
}
